import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 526856F3-6DF1-454A-B905-3DA120370563
 * name playlist-remove
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/playlist-remove.svg
 * tags
 */
export const PlaylistRemoveIcon = createSvgIcon(<><path d="M14 10H3V12H14V10M14 6H3V8H14V6M3 16H10V14H3V16M14.4 22L17 19.4L19.6 22L21 20.6L18.4 18L21 15.4L19.6 14L17 16.6L14.4 14L13 15.4L15.6 18L13 20.6L14.4 22Z" /></>, 'PlaylistRemoveIcon');
export default PlaylistRemoveIcon